import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TeamsResource {
    baseUrl: string;
    resourceName = 'teams';

    constructor(private http: HttpClient) {
        this.baseUrl = [environment.baseUrl, 'v2', this.resourceName].join('/');
    }

    findById(id: string): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/' + id);
    }

    list(): Observable<any> {
        const url = new URL(this.baseUrl + `/list`);

        return this.http.get<any>(url.toString());
    }

    update(id: string, body: any): Observable<any> {
        const url = new URL(this.baseUrl + `/` + id);

        return this.http.put<any>(url.toString(), body);
    }
}
